// config.js
export const env = 'prod0'; // or 'prod'

export const ROOT_URLS = {
  test: 'https://aa2397tzu2-vpce-00569c5e62069a9a0.execute-api.us-east-1.amazonaws.com/roamm_test',
  prod: 'https://aa2397tzu2-vpce-00569c5e62069a9a0.execute-api.us-east-1.amazonaws.com/roamm',
  dev : 'https://hoir9z3512-vpce-00569c5e62069a9a0.execute-api.us-east-1.amazonaws.com/dev',
  prod0 : 'https://res1ynzoma-vpce-00569c5e62069a9a0.execute-api.us-east-1.amazonaws.com/prod'
  
};

export const ENDPOINTS = {
  newAdminDashboard: '/new_admin_dashboard',
  newCampaignDashboard: '/new_campaign_dashboard',
  newGetCsvFiles: '/new_get_csv_files',
  newCognitiveData: '/new_cognitive_data',
  newGetParticipantList: '/new_get_participantlist',
  newGetCampaignList: '/new_get_campaignlist',
  newConfigWatch: '/new_config_watch',
  newGetCoordinatorPermissions: '/new_get_coordinator_permissions',
  newCoordinatorPermission: '/new_coordinator_permission',
  newCreateCampaign: '/new_create_campaign',
  newCreateCoordinator: '/new_create_coordinator',
  newCreateCognitoUser: '/new_create_cognito_user',
  newCreateManager: '/new_create_manager',
  newCreateParticipant: '/new_create_participant',
  newGetWatchConfig: '/new_get_watch_config',
  newUpdateWatchConfig: '/new_update_watch_config',
  newManagerDashboard: '/new_manager_dashboard',
  newParticipantDashboard: '/new_participant_dashboard',
  newGetParticipantAvgForAnalytics: '/new_get_participant_avg_for_analytics',
  UniqueQuestions: '/new_unique_questions',
  newManagerDashboardCreateManager: '/newCreateManager',
  newNumericDataWithTime: '/new_numeric_data_with_time',
  newDownloadReport: '/new_download_report',
  newGetBulkData: '/new_getBulkData',
  newDeleteParticipant: '/new_delete_participant',
};


const getApiUrl = (endpoint) => `${ROOT_URLS[env]}${ENDPOINTS[endpoint]}`;

export default getApiUrl;